/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import React, { useState, useContext } from 'react'
import { Button, Label, Input, FormGroup, Modal } from 'reactstrap'
import { apiAddMissingNIC } from '../../services/api-service'
import { ModalContext } from '../../context/ModalContextProvider'
import { MessageHandlerContext } from '../../context/MessageHandlerContextProvider'
import PropTypes from 'prop-types'
import { trim } from 'lodash'

const NICNumber = (props) => {
  const [nic, setNic] = useState('')
  const { purchaseConfirmModal, setPurchaseConfirmModal } = useContext(ModalContext)
  const { setGlobalLoader, setGlobalMessage } = useContext(MessageHandlerContext)

  const handelOnInput = (event) => {
    setNic(event.target.value)
  }

  const submitNICNumber = async () => {
    if (!trim(nic).match((/^(?:19|20)?\d{2}[0-9]{10}|[0-9]{9}[x|X|v|V]$/))) {
      setGlobalMessage('Invalid NIC Number')
      return
    }
    setGlobalLoader(true)
    try {
      const userLogin = await apiAddMissingNIC({ nic: trim(nic) })
      if (userLogin.status === 200) {
        props.toggle()
        setPurchaseConfirmModal(!purchaseConfirmModal)
      }
    } catch (error) {
      setGlobalMessage(error.message)
    } finally {
      setNic('')
      setGlobalLoader(false)
    }
  }

  return (
    <Modal isOpen={props.opened} toggle={props.toggle} backdrop="static">
      <div className="login_otp">
        <div className="login_otp_wrapper">
          <FormGroup>
            <Label for="nicNumber">Enter NIC number</Label>
            <Input type="text" autoComplete="off" onChange={(event) => handelOnInput(event)} />
          </FormGroup>
          <FormGroup className="mb-0">
            <Button color="warning" block onClick={() => submitNICNumber()}>
              Submit
                    </Button>
          </FormGroup>
        </div>
      </div>
    </Modal>
  )
}

NICNumber.propTypes = {
  opened: PropTypes.bool,
  toggle: PropTypes.func
}

export default NICNumber
